export var CommandStateData;
(function (CommandStateData) {
    let data_type;
    (function (data_type) {
        data_type["COMMAND_STATE_DATA"] = "command_state_data";
    })(data_type = CommandStateData.data_type || (CommandStateData.data_type = {}));
})(CommandStateData || (CommandStateData = {}));
